{
  "name": "saphir-master-frontend",
  "version": "0.1.0",
  "scripts": {
    "ng": "ng",
    "cert:dev": "powershell -NoProfile -ExecutionPolicy Bypass -File scripts/dev-cert.ps1",
    "prestart": "npm run cert:dev",
    "start": "ng serve shell --configuration development --no-open",
    "start:test": "ng serve shell --configuration test",
    "start:prod": "ng serve shell --configuration production",
    "build:contract": "ng build module-contract",
    "sync:contract": "node scripts/sync-contract.mjs",
    "sync:module": "node scripts/sync-module.mjs",
    "build": "ng build shell --configuration production",
    "build:dev": "ng build shell --configuration development",
    "build:test": "ng build shell --configuration test",
    "build:prod": "ng build shell --configuration production",
    "watch": "ng build shell --watch --configuration development",
    "test": "ng test module-contract && ng test shell",
    "test:watch": "ng test shell --watch",
    "format": "prettier --write \"projects/**/*.{ts,html,scss,json}\"",
    "format:check": "prettier --check \"projects/**/*.{ts,html,scss,json}\"",
    "docs:pdf": "node scripts/build-docs-pdf.mjs",
    "feed:prune": "node scripts/prune-modules-feed.mjs"
  },
  "private": true,
  "packageManager": "npm@10.9.8",
  "dependencies": {
    "@angular/common": "^22.1.0",
    "@angular/compiler": "^22.1.0",
    "@angular/core": "^22.1.0",
    "@angular/forms": "^22.1.0",
    "@angular/platform-browser": "^22.1.0",
    "@angular/router": "^22.1.0",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "@primeuix/themes": "^2.0.3",
    "@saphir/auth-client": "^0.3.0",
    "@saphir/calendar-module": "^0.1.13",
    "@saphir/fakt-module": "^0.1.606",
    "@saphir/fleet-module": "^0.1.17",
    "@saphir/lohn-module": "^0.1.53",
    "@saphir/module-contract": "^0.5.2",
    "primeicons": "^7.0.0",
    "primeng": "^21.1.9",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^22.1.3",
    "@angular/cli": "^22.1.3",
    "@angular/compiler-cli": "^22.1.0",
    "jsdom": "^28.0.0",
    "marked": "^18.0.10",
    "ng-packagr": "^22.1.0",
    "prettier": "^3.8.1",
    "typescript": "~6.0.2",
    "vitest": "^4.0.8"
  }
}
